export default function Signature() {
  return (
    <div className="w-[90vw] max-w-[1225px] mx-auto px-4 mb-1">
      <div className="flex justify-end pr-4">
        <a 
          href="https://www.linkedin.com/in/fareehas" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-xs engraved-text hover:text-white/90 transition-colors duration-200"
        >
          sincerely, Fareeha
        </a>
      </div>
    </div>
  );
}
